import './toolKit.css';
import BubbleTitle from '../../../../components/bubbleTitle/bubbleTitle';
import ToolCards from '../../../../components/toolCards/toolCards';
import ToolFlipCards from '../../../../components/toolFlipCards/toolFlipCards';

import TrackExpenses from '../../../../assets/icons/trackExpenses/trackExpenses';
import CustomReports from '../../../../assets/icons/customReports/customReports';
import AnalizeData from '../../../../assets/icons/analizeData/analizeData';

export default function ToolKit({isMobile}){

    /*const mobileBreakPoint = window.innerWidth;

    const isMobile = () => {
        if (mobileBreakPoint < 640) {
            return true;
        } else {
            return false;
        }
    };*/

    return(
        <div className="tool-kit">
            <BubbleTitle title={<h1>Your <span>Expensible</span> Tool Kit</h1>} />

            <p className="tool-kit-title-text-content">All-in-one tools to track expenses, analyze trends, and create custom reports.</p>

            {isMobile ? 
            
            <div className="mobile-tool-kit-content-container">
                <ToolFlipCards flipQuantity={true} cardSize={true}
                                iconOne={<TrackExpenses/>} iconTwo={<CustomReports/>} iconThree={<AnalizeData/>}
                                titleOne='Track Expenses' titleTwo='Custom Reports' titleThree='Analize Data' 
                                barBool={true} barWidth={'80%'} barCenter={'auto'}
                                subTitleOne={'Capture every cost, your way!'} subTitleTwo={'Tailor reports to any stakeholder'} subTitleThree={'Turn spend into insight & forecasts'}
                                textContentTopOne={'Create and customize expense categories to match your business workflows and capture receipts, notes, and attachments on the go.'} 
                                textContentTopTwo={'Build, save, and schedule shareable reports from your expense data — filter by project, department, vendor, date range, or custom tags.'}
                                textContentTopThree={'Visualize expense trends across timelines, detect anomalies, and use historical data to forecast future budgets and cash needs.'}
                                bulletPointsOne={[
                                    "Capture receipts, notes, and attachments on the go.",
                                    "Customizable fields, tags, and rules specific to your company.",
                                    "Record expenses in any currency and flag tax-deductible items.",
                                    "Route expenses to approvers with comments and status tracking."]} 
                                bulletPointsTwo={[
                                    "Drag-and-drop builder: Select fields, groupings, and visualizations without code.",
                                    "Pre-built templates: Quick templates for payroll, travel spend, vendor audits, and monthly P&L.",
                                    "Export & share: PDF, CSV or direct email scheduling to stakeholders. Permissions-aware: Generate reports that respect user roles and data visibility.",
                                    ]} 
                                bulletPointsThree={[
                                    "Time-series dashboards: Compare monthly, quarterly, and yearly trends. Trend detection & alerts: ",
                                    "Automatically flag spikes, recurring overruns, or unusual vendor activity.",
                                    "Predictive forecasting: Project future spend by category using historical patterns.",
                                    "Scenario modeling: Run “what-if” scenarios (e.g., +10% travel) to see budget impact."
                                    ]}
                                
                                />
            </div> 
            
            :
            
            <div className="tool-kit-content-container">
                
                <ToolCards
                 size={true} 
                 icon={<TrackExpenses/>} 
                 title={"Track Expenses"} 
                 barBool={true}
                 barWidth={'18rem'}
                 barCenter={'auto'} 
                 subTitle={"Capture every cost, your way!"}
                 textContentTop={"Create and customize expense categories to match your business workflows and capture receipts, notes, and attachments on the go."}
                 bulletPoints={[
                    "Capture receipts, notes, and attachments on the go.",
                    "Customizable fields, tags, and rules specific to your company.",
                    "Record expenses in any currency and flag tax-deductible items.",
                    "Route expenses to approvers with comments and status tracking."]}
                 buttonBool={false}
                 />

                 <div className="tool-kit-spacer"><ToolCards
                 size={true} 
                 icon={<CustomReports/>} 
                 title={"Custom Reports"} 
                 barBool={true}
                 barWidth={'18rem'}
                 barCenter={'auto'} 
                 subTitle={"Tailor reports to any stakeholder"}
                 textContentTop={"Build, save, and schedule shareable reports from your expense data — filter by project, department, vendor, date range, or custom tags."}
                 bulletPoints={[
                    "Drag-and-drop builder: Select fields, groupings, and visualizations without code.",
                    "Pre-built templates: Quick templates for payroll, travel spend, vendor audits, and monthly P&L.",
                    "Export & share: PDF, CSV or direct email scheduling to stakeholders. Permissions-aware: Generate reports that respect user roles and data visibility.",
                    ]}
                 buttonBool={false}
                 /></div>

                 <ToolCards
                 size={true} 
                 icon={<AnalizeData/>} 
                 title={"Analize Data"} 
                 barBool={true} 
                 barWidth={'18rem'}
                 barCenter={'auto'}
                 subTitle={"Turn spend into insight & forecasts"}
                 textContentTop={"Visualize expense trends across timelines, detect anomalies, and use historical data to forecast future budgets and cash needs."}
                 bulletPoints={[
                    "Time-series dashboards: Compare monthly, quarterly, and yearly trends. Trend detection & alerts: ",
                    "Automatically flag spikes, recurring overruns, or unusual vendor activity.",
                    "Predictive forecasting: Project future spend by category using historical patterns.",
                    "Scenario modeling: Run “what-if” scenarios (e.g., +10% travel) to see budget impact."
                    ]}
                 buttonBool={false}
                 />

            </div>}
        </div>
    )
};